/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ReelManager from '../Reel/ReelManager';
import InjectableComponent from '../Utility/Component/ComponentReference/InjectableComponent';
import Effect from './Effect';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/**
 * Effect used to increase / decrease stop delay of ReelManager.
 */
@cc._decorator.ccclass
export default class AddReelsDelayEffect extends Effect
{
    /**
     * ReelManager reference to add delay to.
     */
    @property({ type: InjectableComponent })
    protected reelManagerRef: InjectableComponent<ReelManager> = new InjectableComponent<ReelManager>();

    /**
     * Time in seconds to delay stop of all reels.
     */
    @property()
    protected time: number = 1;

    /** @hidden */
    protected setContexts(): void
    {
        super.setContexts();

        this.reelManagerRef.SetContext(ReelManager);
    }

    /** Adds time property stop delay for each reel. */
    protected trigger = (): void =>
    {
        if (!this.reelManagerRef.Value) { return; }

        for (let reel of this.reelManagerRef.Value.Reels)
        {
            if (reel.HasLanded) { continue; }

            reel.AddStopDelay(this.dtModRef.Value.Reduce(this.time));
        }

        this.complete();
    }
}
